import { Download, ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { CAPABILITY_DOC_URL, IMAGES } from "../../lib/siteData";

export const Hero = () => {
  return (
    <section id="hero" data-testid="hero-section" className="relative overflow-hidden bg-white pt-[72px]">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-28 lg:px-8">
        <div>
          <Reveal>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-forest/15 bg-forest-50 px-4 py-1.5">
              <span className="h-2 w-2 rounded-full bg-lime-bright" />
              <span className="font-body text-xs font-semibold uppercase tracking-widest text-forest">
                Multi-Partner Sustainability Platform
              </span>
            </div>
          </Reveal>

          <Reveal delay={80} as="h1" className="font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-forest sm:text-5xl lg:text-6xl">
            Sustainable, smart, resilient assets.
            <span className="block text-forest-600">Better OPEX. One coordinated consortium.</span>
          </Reveal>

          <Reveal delay={160} as="p" className="mt-6 max-w-xl font-body text-base leading-relaxed text-muted-foreground lg:text-lg">
            We bring together sustainability consulting, landscape design, renewable energy,
            intelligent lighting, and digital performance management to help developers and
            infrastructure owners improve long-term asset performance.
          </Reveal>

          <Reveal delay={240} className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#contact"
              data-testid="hero-talk-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-forest px-7 py-3.5 font-body text-sm font-semibold text-white transition-colors hover:bg-forest-600"
            >
              Talk to the Consortium <ArrowRight size={17} />
            </a>
            <a
              href={CAPABILITY_DOC_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-download-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-forest/20 px-7 py-3.5 font-body text-sm font-semibold text-forest transition-colors hover:bg-forest-50"
            >
              <Download size={17} /> Download Capability Document
            </a>
          </Reveal>
        </div>

        <Reveal delay={200} className="relative">
          <div className="relative overflow-hidden rounded-2xl border border-border">
            <img
              src={IMAGES.hero}
              alt="Sustainable modern infrastructure"
              className="h-[380px] w-full object-cover grayscale lg:h-[520px]"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-forest/30 to-transparent" />
          </div>
          <div className="absolute -bottom-5 -left-5 hidden rounded-xl border border-border bg-white p-5 shadow-sm sm:block">
            <div className="font-heading text-3xl font-extrabold text-forest">5</div>
            <div className="font-body text-xs font-medium uppercase tracking-wider text-muted-foreground">
              Specialist Partners
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
